import { LoadingSection } from 'components/LoadingSection';
import { useSuspendedUIDelay } from 'hooks/useDelay';

export function LoadableLoadingSection() {
  const { pastDelay } = useSuspendedUIDelay();
  if (!pastDelay) return null;

  return <LoadingSection noDelay />;
}
